import { useEffect } from 'react';
import Clarity from '@microsoft/clarity';

const enableClarity = () => {
    Clarity.init('qtqf16aexs');
};

const loadClarityScripts = () => {
    if (window.dataLayer?.some((data) => data?.[0] === 'consent' && data?.[2]?.analytics_storage === 'granted')) {
        if ('requestIdleCallback' in window) {
            requestIdleCallback(enableClarity, { timeout: 3000 });
        } else {
            setTimeout(enableClarity, 3000);
        }

        return;
    }

    setTimeout(loadClarityScripts, 10000);
}

export const ClarityScript = () => {
    useEffect(() => {
        if (window.clarity || process.env['NODE_ENV'] === 'development') {
            return;
        } 
        
        loadClarityScripts();
    }, []);

    return null;
}